var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"summary-card is-courses"},[_c('div',[_c('span',[_vm._v("دوره‌های من")]),_c('strong',[_vm._v(_vm._s(_vm.totalCount))]),_c('small',[_vm._v("دوره فعال")])]),_c('img',{attrs:{"src":require("../../../../../public/course.webp"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }